import '@assets/css/skeleton.css';

export const ServiceListSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <div className="d-flex flex-column gap-4">
      {[1, 2].map((groupIdx) => (
        <div key={groupIdx}>
          <div className="d-flex align-items-baseline justify-content-between mb-2">
            <div className="shimmer" style={{ height: 24, width: '30%' }} />
            <div className="shimmer" style={{ height: 16, width: '15%' }} />
          </div>
          <hr className="mt-0 mb-3" />
          <div className="d-flex flex-column gap-3">
            {Array.from({ length: count }).map((_, idx) => (
              <div key={idx} className="border rounded-3 p-3">
                <div className="d-flex flex-wrap gap-3">
                  <div className="shimmer" style={{ width: 80, height: 80, borderRadius: 8 }} />
                  <div className="flex-grow-1">
                    <div className="shimmer" style={{ height: 22, width: '40%', marginBottom: 8 }} />
                    <div className="shimmer" style={{ height: 18, width: '30%', marginBottom: 8 }} />
                    <div className="d-flex gap-1">
                      <div className="shimmer" style={{ height: 22, width: 60, borderRadius: 20 }} />
                      <div className="shimmer" style={{ height: 22, width: 60, borderRadius: 20 }} />
                    </div>
                    <div className="shimmer" style={{ height: 16, width: '30%', marginTop: 8 }} />
                  </div>
                  <div className="d-flex align-items-center gap-3 align-self-center">
                    <div className="shimmer" style={{ height: 24, width: 70, borderRadius: 4 }} />
                    <div className="shimmer" style={{ height: 32, width: 60, borderRadius: 4 }} />
                    <div className="shimmer" style={{ height: 32, width: 60, borderRadius: 4 }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};